import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class UsersAdminApi {
    getConfig() {
        const token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin')).token : ''
        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    getUsers() {
        return axios.get(`${URL_API}/admin/usuarios`, this.getConfig())
    }

    changeProfile(userId, status) {
        return axios.put(`${URL_API}/admin/trocar-perfil/${userId}/${status}`, {}, this.getConfig())
    }

    setBlockUser(userId, status) {
        return axios.put(`${URL_API}/admin/bloqueio-desbloqueio/${userId}/${status}`, {}, this.getConfig())
    }

    deleteUser(userId) {
        return axios.delete(`${URL_API}/admin/excluir-usuario/${userId}`, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/admin/users-admin-api/UsersAdminApi.js